import { FC, PropsWithChildren } from "react";
import { LoadingAnimation } from "@/components/LoadingAnimation";
import useLanguageProvider from "../hooks/useLanguageProvider";

interface ILanguageProviderProps extends PropsWithChildren {}

const LanguageProvider: FC<ILanguageProviderProps> = ({ 
  children, 
}) => {

  const { loaded, isFetching } = useLanguageProvider();

  return <>
    {!loaded && isFetching && <LoadingAnimation/>}
    {loaded && children}
  </>
}

export default LanguageProvider;

